import React, { useCallback, useEffect, useRef, useState } from 'react';
import SVG from './SVG.jsx';
import trackEvent from '../utils/trackEvent';

export default function ProductVideo(props) {
  const { featured, handle, productName, className } = props;
  const videoRef = useRef(null);
  const [videoMuted, setVideoMuted] = useState(true);
  const [videoPlaying, setVideoPlaying] = useState(true);

  let autoPaused = true;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        if (videoRef.current && autoPaused) {
          videoRef.current.play();
          autoPaused = false;
        }
      } else {
        if (videoRef.current && !videoRef.current.paused) {
          videoRef.current.pause();
          if (!autoPaused) {
            autoPaused = true;
          }
        }
      }
    });
  }, {
    rootMargin: '-1%'
  })

  useEffect(() => {
    if (videoRef.current) {
      const playHandler = () => setVideoPlaying(true);
      const pauseHandler = () => setVideoPlaying(false);
      const volumeChangeHandler = () => {
        if (videoRef.current) setVideoMuted(videoRef.current.muted);
      };

      videoRef.current.addEventListener('play', playHandler);
      videoRef.current.addEventListener('pause', pauseHandler);
      videoRef.current.addEventListener('volumechange', volumeChangeHandler);
      io.observe(videoRef.current);

      return () => {
        videoRef.current.removeEventListener('play', playHandler);
        videoRef.current.removeEventListener('pause', pauseHandler);
        videoRef.current.removeEventListener('volumechange', volumeChangeHandler);
        io.unobserve(videoRef.current);
      };
    }
  }, [videoRef.current]);

  useEffect(() => {
    if (videoRef.current) {
      if (videoPlaying && videoRef.current.paused) {
        videoRef.current.play();
      } else if (!videoPlaying && !videoRef.current.paused) {
        videoRef.current.pause();
      }
    }
  }, [videoPlaying]);

  useEffect(() => {
    if (videoRef.current) {
      if (videoMuted) {
        videoRef.current.muted = true;
      } else {
        videoRef.current.muted = false;
      }
    }
  }, [videoMuted]);

  let playedTimeout = null;

  const videoPlayed = useCallback(() => {
    clearTimeout(playedTimeout);
    playedTimeout = setTimeout(() => {
      if (videoRef.current && !videoRef.current.paused && videoPlaying) {
        trackEvent('WatchedExplainerVideo', { productTitle: productName, handle: handle, buttonText: featured.alt, mediaId: featured.id });
      }
    }, 1000);
  }, [productName, handle, featured.alt, featured.id, videoPlaying, videoRef.current]);

  return (
    <div className={`video-wrap ${className}`}>
      <video ref={videoRef} onPlaying={videoPlayed} className='product-video current-image' height={featured.height} width={featured.width} loop playsInline muted={videoMuted} data-poster={JSON.stringify(featured.preview_image)} onClick={() => setVideoPlaying(!videoPlaying)}>
        {featured.sources.sort((a, b) => b.height - a.height).map((source, i) =>
          <source type={source.mime_type} height={source.height} width={source.width} src={source.url} key={i} />
        )}
      </video>
      <div className="video-controls">
        {videoMuted ? <button className="video-control video-control-unmute" onClick={() => setVideoMuted(false)}><SVG icon="unmute" /></button> : <button className="video-control video-control-mute" onClick={() => setVideoMuted(true)}><SVG icon="mute" /></button>}
        {videoPlaying ? <button className="video-control video-control-pause" onClick={() => setVideoPlaying(false) }><SVG icon="pause" /></button> : <button className="video-control video-control-play" onClick={() => setVideoPlaying(true)}><SVG icon="play" /></button>}
      </div>
    </div>
  )
}